import { useCallback, useEffect, useState } from 'react';

type UseCellValidationArgs = {
  validationAttempt: number;
};

const useCellValidation = ({ validationAttempt = 0 } : UseCellValidationArgs) => {
  const [acknowledgedCells, setAcknowledgedCells] = useState<Set<string>>(new Set());

  useEffect(() => {
    setAcknowledgedCells(new Set());
  }, [validationAttempt]);

  const getCellKey = useCallback((rowIndex: number, columnId: string) => `${rowIndex}-${columnId}`, []);

  const handleCellClick = useCallback((rowIndex: number, columnId: string) => {
    const cellKey = getCellKey(rowIndex, columnId);
    setAcknowledgedCells(prev => new Set([...prev, cellKey]));
  }, [getCellKey]);

  return { acknowledgedCells, getCellKey, handleCellClick };
};

export default useCellValidation;
